<template>
  <button
    class="btn btn-primary btn-danger"
    :disabled="isEnding"
    @click="handleClick">
    <i class="fa fa-fw fa-stop" />
    {{ label }}
  </button>
</template>

<script>
import { workShiftService } from "@/_shared/api-services";
import { useNotification } from "@/_shared/mixins";
export default {
  mixins: [useNotification],
  emits: ['on-end'],
  props: {
    label: {
      type: String,
      default: 'Завершить смену',
      validator(value) {
        const possibleValues = ['Завершить смену', 'Обновить дату завершения'];
        return !!possibleValues.includes(value);
      },
    },
  },
  data() {
    return {
      isEnding: false,
    };
  },
  methods: {
    async handleClick() {
      this.isEnding = true;
      await workShiftService.end()
        .then((endDate) => this.$emit('on-end', endDate))
        .catch(({ message }) => this.showErrorNotification(message))
        .finally(() => this.isEnding = false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/_shared/features/work-shift-menu/EndButton.vue